class Logger {
    constructor() {
        window.loggerEnabled = !(process.env.NODE_ENV === 'production');
    }
    log(...output) {
        if (!window.loggerEnabled) {
            return;
        }
        console.log(...output);
    }
    warn(...output) {
        if (!window.loggerEnabled) {
            return;
        }
        console.warn(...output);
    }
    error(...output) {
        if (!window.loggerEnabled) {
            return;
        }
        console.error(...output);
    }
}
const logger = new Logger();
export { logger };
